import {PropsFromReduxInclusions} from '../containers/inclusionContainers';
import {useLocation} from 'react-router-dom';
import React, {useEffect, useRef, useState} from 'react';
import {IInclusions} from '../reducers/inclusionsReducers';
import {toast} from 'react-toastify';
import history from '../../../routes/history';
import {DataGridPro, GridColumns, GridValueGetterParams} from '@mui/x-data-grid-pro';
import {Box, Checkbox, Tab, Tabs} from '@mui/material';
import Loader from '../../common/Loader';
import PaginationComponent from '../../common/PaginationComponent';
import { Toolbar } from './ToolBar/Toolbar';
import { CustomTooltip } from '../../../utils/CustomTooltip'
import {PictureAsPdf} from '@mui/icons-material';
import PdfPreview from '../../../utils/PdfPreview';
import {REFACTOR_URL} from '../../../helpers/env';

interface IPreviewPosition {
  x: number
  y: number
  fileId?: number | null
}
const InclusionComponent = (
    props: PropsFromReduxInclusions & {
      patientId?: number
      forceReload?: boolean
    }
) => {
  const location = useLocation()
  const q = useRef(new URLSearchParams(location.search)).current
  
  const { userSettings }  = { ...props }
  const intialFilePreviewPosition: IPreviewPosition = {
    x: 0,
    y: 0,
    fileId: null,
  }
  const [delayPdfHover, setDelayPdfHover] = useState(setTimeout(() => {}, 1))
  const [filePreviewPosition, setFilePreviewPosition] =
      useState(intialFilePreviewPosition)
  const [data, setData] = useState<IInclusions[]>([])
  const [activeTab, setActiveTab] = useState(userSettings.activeTab)
  const [rowsPerPage, setRowsPerPage] = useState(
      q.has('limit')
          ? parseInt(q.get('limit') as string)
          : parseInt(localStorage.getItem('rowsPerPage') as string),
  )
  const [activePage, setActivePage] = useState(userSettings.activePage)
  const [loading, setLoading] = useState<boolean>(true)
  const [selectAll, setSelectAll] = useState<boolean>(false)
  
  useEffect(() => {
    if (activeTab !== 0) {
      props.setUserSettings({
        activeTab,
        activePage,
        rowsPerPage,
      })
      fetchData(false).then()
    }
  }, [activeTab])
  
  const patientId = props.patientId
  useEffect(() => {
    fetchData(false).then()
  }, [patientId])
  
  useEffect(() => {
    console.log(`use Effect active Tab : ${activeTab} and userSettings ${props.userSettings.activeTab} comp ${activePage !== props.userSettings.activeTab}`)
      props.setUserSettings({
        activeTab,
        activePage,
        rowsPerPage
      })
      fetchData(false).then(() => {
        console.log(` after fetch active Tab : ${activeTab} and userSettings ${props.userSettings.activeTab}`)
      })
    if (activePage !== props.userSettings.activeTab) {
      console.log('difference')
    }
  }, [activeTab])
  useEffect(() => {
    if (rowsPerPage !== props.userSettings.rowsPerPage || activePage !== props.userSettings.activePage) {
      props.setUserSettings({
        activeTab,
        activePage,
        rowsPerPage
      })
      fetchData(false).then()
    }
  }, [rowsPerPage, activePage])
  
  useEffect(() => {
    !loading ? setData(props.inclusions.data) : setData([])
  }, [loading, props.inclusions])
  
  const forceReload = props.forceReload ? props.forceReload : false
  useEffect(() => {
    if (forceReload) {
      fetchData(false).then()
    }
  }, [forceReload])
  
  const fetchData = async (loader: boolean) => {
    console.log(`start fetchData with loader ${loader}`)
    loader && setLoading(true)
    try {
      await props.getInclusionsSummary(props.patientId || null)
    }catch {
      toast.error(`Impossible de charger le nombre d'inclusions`)
    } finally {
      setLoading(false)
    }
    loader && setLoading(true)
    try {
      await props.getInclusions(activePage, rowsPerPage, activeTab === 1, props.patientId || null)
    } catch {
      toast.error(`Impossible de charger les inclusions`)
    } finally {
      setLoading(false)
    }
  }
  
  const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
    console.log(`handle Table change with newValue ${newValue}`)
    setData([])
    setActiveTab(newValue)
    setActivePage(1)
  }
  
  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    }
  }
  
  function isMakerAdmin(): boolean {
    return (
        props.user?.userDataRoles.findIndex(
            (role: { id: number; roleName: string }) => {
              return role.roleName === 'MakerAdmin' || role.roleName === 'MakerSales'
            },
        ) !== -1
    )
  }
  
  const handleRefresh = () => {
    console.log('request to refresh')
    fetchData(false).then()
  }
  
  function handelSelectAll() {
    const currentData: IInclusions[] = []
    console.log(`handle select all with data ${JSON.stringify(data)}`)
    if (data) {
      data.forEach((inclusion: any) => {
        const currentInclusions = { ...inclusion }
        currentInclusions.checked = !inclusion.checked
        currentData.push(currentInclusions)
      })
    }
    console.log(`handle select complete with data ${JSON.stringify(currentData)}`)
    setData(currentData)
    setSelectAll(!selectAll)
  }
  
  function handleSelectChange(event: any) {
    console.log(`row change ${JSON.stringify(event)}`)
    const currentData: IInclusions[] = []
    data.forEach((inclusion: any) => {
      currentData.push(inclusion)
    })
    const index = currentData.findIndex((inclusion) => {
      return inclusion.id === event.id
    })
    console.log(` inclusion index ${index}`)
    const inclusion = { ...currentData[index] }
    inclusion.checked = !inclusion.checked
    currentData[index] = inclusion
    setData(currentData)
  }
  
  const handleClickFile = (data: string) => {
    console.log(`documentRef ${data}`)
    clearTimeout(delayPdfHover)
    setFilePreviewPosition(intialFilePreviewPosition)
    history.push(`/full-pdf`, {
      path: REFACTOR_URL,
      url: `stored_file/${data}`,
    })
  }
  const onFileHover = (
      event: React.MouseEvent<HTMLDivElement>,
      row: any,
  ) => {
    setDelayPdfHover(
        setTimeout(() => {
          const height = window.innerHeight * 0.8
          const width = (height * 210) / 297
          
          const x = event.clientX - (width + 150)
          const y = window.scrollY + 10
          console.log(`onFileHover height ${height} width ${width} x ${x} y ${y} clentX ${event.clientX}`)
          setFilePreviewPosition({ x, y, fileId: row.file?.id})
        }, 500),
    )
  }
  
  const onFileLeave = () => {
    clearTimeout(delayPdfHover)
    setFilePreviewPosition(intialFilePreviewPosition)
  }
  
  async function handleDownload(event: any) {
    event.preventDefault()
    for (const inclusion of data) {
      if (inclusion.checked) {
        const blob: Blob = await props.getFilePdf(
            inclusion.file?.id,
        )
        const fileDownloadUrl = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.setAttribute('href', fileDownloadUrl)
        a.setAttribute('download', String(inclusion.file.id))
        a.setAttribute('target', '_blank')
        a.click()
        URL.revokeObjectURL(fileDownloadUrl)
        console.log(`active Tab ${activeTab} and inclusionId ${inclusion.id}`)
        if (activeTab === 0) {
          props.updateInclusionMakerReaded(inclusion.id).finally(() => {
            handelSelectAll()
            fetchData(false)
          })
        }
      }
    }
  }
  
  const columns: GridColumns = [
    {
      field: 'select',
      renderHeader: () => {
        return (
            <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
            >
              <span>Sélection</span>
              <CustomTooltip text="Tout sélectionner">
                <Checkbox
                    onChange={handelSelectAll}
                    checked={selectAll}
                ></Checkbox>
              </CustomTooltip>
            </Box>
        )
      },
      width: 120,
      sortable: false,
      renderCell: (params) => {
        return (
            <Checkbox
                checked={params.row.checked}
                onChange={() => handleSelectChange(params.row)}
            ></Checkbox>
        )
      },
    },
    {
      field: 'col1',
      headerName: 'Nom Prénom',
      width: 200,
      sortable: false,
      renderCell: (params) => (
          
            <CustomTooltip
                text={
                  <p
                      style={{
                        margin: 0,
                        fontSize: '13px',
                        overflow: 'hidden',
                      }}
                  >
                    {params.row.implantation.patient.patient_name
                        ? params.row.implantation.patient.patient_name.toUpperCase()
                        : ''}{' '}
                    <br />
                    <span style={{ textTransform: 'capitalize' }}>
                  {' '}
                      {params.row.implantation.patient.first_name
                          ? params.row.implantation.patient.first_name
                          : ''}
                </span>
                  </p>
                }
            >
              <Box>
                {params.row.implantation.patient.patient_name
                    ? params.row.implantation.patient.patient_name.toUpperCase()
                    : ''}{' '}
                <br />
                <span style={{ textTransform: 'capitalize' }}>
                {' '}
                  {params.row.implantation.patient.first_name
                      ? params.row.implantation.patient.first_name
                      : ''}
              </span>
              </Box>
            </CustomTooltip>
      ),
    },
    {
      field: 'col2',
      headerName: 'Numéro de sécurité sociale',
      width: 200,
      sortable: false,
      valueGetter: (params: GridValueGetterParams) =>
          `${params.row.implantation.patient.social_insurance_number ? params.row.implantation.patient.social_insurance_number : 'non défini'}`,
    },{
      field: 'col3',
      headerName: 'Centre',
      width: 200,
      sortable: false,
      valueGetter: (params: GridValueGetterParams) =>
          `${params.row.implantation.patient.patient_center[0].company.company_name ? params.row.implantation.patient.patient_center[0].company.company_name : 'non défini'}`,
    },{
      field: 'col4',
      headerName: 'Type de fichier',
      width: 200,
      sortable: false,
      valueGetter: (params: GridValueGetterParams) =>
          `${params.row.file.display_name ? params.row.file.display_name : 'non défini'}`,
    },
    {
      field: 'col7',
      headerName: 'Fichier',
      width: 200,
      sortable: false,
      renderCell: (params) => (
          <div
              style={{
                display: 'flex',
                alignItems: 'start',
                flexDirection: 'column',
              }}
          >
            {params.row.file?.id ? (
                <div
                    onMouseEnter={(event) => onFileHover(event, params.row)}
                    onMouseLeave={() => onFileLeave()}
                >
                  <CustomTooltip>
                    <div
                        key={params.row.file?.id}
                        className="button-alert-pdf"
                        onClick={() => {
                          handleClickFile(params.row.file?.id)
                        }}
                    >
                      <PictureAsPdf sx={{ color: 'red', fontSize: '20px' }} />
                      <p
                          style={{
                            margin: 0,
                            fontWeight: 'bold',
                          }}
                      >
                    <span
                        style={{
                          fontSize: '12px',
                          fontWeight: 'bold',
                          color: 'gray',
                        }}
                    >
                      Détails
                    </span>
                      </p>
                    </div>
                  </CustomTooltip>
                </div>
            ) : (
                `Pas de fichier`
            )}
          </div>
      ),
    },
  ]
  
  return (
      <>
        <Box sx={{ height: 'calc(100vh - 240px)', width: '100%'}}>
          <Loader open={loading} text="En attente" />
          <Tabs
              TabIndicatorProps={{ style: {
                  backgroundColor: '#ffa726',
                  display: 'flexWrap',
                }
                }}
              onChange={handleTabChange}
              textColor="primary"
              value={activeTab}>
            {isMakerAdmin() && (
                <Tab
                    label={`A charger: ${
                      loading ? 0 : props.inclusionsSummary?.toRead
                    }`}
                    {...a11yProps(0)}
                    wrapped={false}/>
            )}
            {isMakerAdmin() && (
                <Tab
                    label={`Chargées: ${
                        loading ? 0 : props.inclusionsSummary?.read
                    }`}
                    {...a11yProps(0)}
                    wrapped={false}/>
            )}
          </Tabs>
          <DataGridPro
              columns={columns}
              rows={data ? data : []}
              components={{
                Toolbar,
              }}
              pagination={false}
              componentsProps={{
                toolbar: {
                  title: 'Inclusions',
                  onRefresh: handleRefresh,
                  onDownload: handleDownload,
                },
                pagination: false,
              }}
              pageSize={rowsPerPage}
              hideFooter
              rowsPerPageOptions={undefined}
              rowHeight={60}
              disableColumnMenu
              disableSelectionOnClick
              disableColumnSelector
              // columnVisibilityModel={columVisibility}
              sx={{
                border: 'none',
                padding: '3px 15px',
              }}
          />
          <PaginationComponent
              pages={0}
              activePage={activePage}
              rowsPerPage={rowsPerPage}
              setActivePage={setActivePage}
              setRowsPerPage={setRowsPerPage}
          />
          {filePreviewPosition.fileId && (
              <PdfPreview
                  onClose={() => {
                    setFilePreviewPosition(intialFilePreviewPosition)
                  }}
                  style={{
                    position: 'absolute',
                    top: filePreviewPosition.y,
                    left: filePreviewPosition.x,
                    zIndex: 1000,
                  }}
                  getPDF={() => {
                    return props.getFilePdf(
                        filePreviewPosition.fileId
                            ? filePreviewPosition.fileId
                            : null,
                    )
                  }}
              />
          )}
        </Box>
      </>
  )
}

export default InclusionComponent
